import _colors from 'styles/global/_colors'
import type { GuidanceType } from './components/ComparisonTabs'

export const MAX_DYNAMIC_COLUMNS = 5

export const PL_GUIDANCE_TYPES: GuidanceType[] = ['expert', 'typical', 'floor']

export const DYNAMIC_COLORS: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: _colors.agGridDynamicColor1,
  2: _colors.agGridDynamicColor2,
  3: _colors.agGridDynamicColor3,
  4: _colors.agGridDynamicColor4,
  5: _colors.agGridDynamicColor5,
}

export const ERROR_MESSAGES = {
  LOAD_FAILED: 'Failed to load edit page data',
  LOAD_FAILED_RETRY: 'Failed to load edit page data. Please try again.',
  REFRESH_PAGE: 'Error loading data. Please refresh the page.',
  NO_DATA: 'No data available for this deal.',
  DEAL_LOAD_TIMEOUT:
    'Deal loading is taking longer than expected. Please refresh the page or try again later.',
} as const

export const GUIDANCE_OPTIONS = [
  { _id: 'expert', label: 'Expert' },
  { _id: 'typical', label: 'Typical' },
  { _id: 'floor', label: 'Floor' },
  { _id: 'top25', label: 'Top 25%' },
  { _id: 'median', label: 'Median' },
  { _id: 'bottom25', label: 'Bottom 25%' },
] as const
